import gsap from "./gsap.min";
import Util from "./Util";

export default class MoreToggle {
  constructor(_target) {

    this.CL_OPEN = "isOpen";

    this.isOpen = false;
    this.time = 0.3;
    this.easing = "power3.out";

    this.btnToggle = _target;
    this.target = document.querySelector('[data-more_id="'+this.btnToggle.dataset.target_id+'"]');
    this.tmpH = window.getComputedStyle(this.target).height;

    this.closeTarget = document.querySelector('[data-more_parent="'+this.btnToggle.dataset.target_id+'"]');
    if(!this.closeTarget) this.closeTarget = this.target.parentElement;

    this.btnToggle.addEventListener('click',()=>{this.onToggle()});

    const mediaQuery = window.matchMedia('(max-width: ' + Util.BREAK_POINT + 'px)');
    mediaQuery.addEventListener('change',this.onMediaQueryChange.bind(this));
    this.onMediaQueryChange(mediaQuery);
  }

  onMediaQueryChange(e) {
    if(e.matches){

    } else {
      gsap.killTweensOf(this.target);
      this.isOpen = false;
      this.btnToggle.classList.remove(this.CL_OPEN);
      this.target.style.height = "";
    }
  }

  onToggle(){
    if(this.isOpen){
      this.onClose();
    } else {
      this.onOpen();
    }
  }

  onOpen(){
    this.isOpen = true;

    const h = this.target.scrollHeight+"px";

    this.btnToggle.classList.add(this.CL_OPEN);
    gsap.killTweensOf(this.target);
    gsap.to(this.target,{duration:this.time,height:h,ease:this.easing,onComplete:()=>{
        this.target.style.height = "auto";
      }
    });

  }

  onClose(){
    this.isOpen = false;

    this.btnToggle.classList.remove(this.CL_OPEN);
    gsap.killTweensOf(this.target);
    this.closeTarget.scrollIntoView({behavior:"smooth",block:"start"});
    gsap.to(this.target,{duration:this.time,height:this.tmpH,ease:this.easing,onComplete:()=>{

      }
    });
  }
}
